import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { cancelEditBalance, createBalance } from '../../../../../actions/loan'
import {
  selectLoanSaving,
  selectEditableLoanCanonicalID,
  selectEditableLoanEstimatedBalance,
  selectEditableLoanHomeID,
  selectEditableLoanAmount,
} from '../../../../../store/selectors/home/loans'
import { Button, Panel, Form, FormField, Format, Text } from '../../../..'
import DollarInput from '../../../../shared/Input/DollarInput'

import styles from './EditBalanceForm.module.scss'

const dollarsFieldName = FormField.Dollars.defaultProps.name

const EditBalanceForm = () => {
  const saving = useSelector(selectLoanSaving)
  const homeId = useSelector(selectEditableLoanHomeID)
  const loanId = useSelector(selectEditableLoanCanonicalID)
  const estimatedValue = useSelector(selectEditableLoanEstimatedBalance)
  const loanAmount = useSelector(selectEditableLoanAmount)
  const dispatch = useDispatch()

  const dollarConditions = [DollarInput.maxCondition(loanAmount)]

  return (
    <Form
      fields={[
        {
          name: dollarsFieldName,
          parse: DollarInput.parseValue,
          conditions: dollarConditions,
        },
      ]}
      className={styles.form}
      onSubmit={(e, data) => {
        e.preventDefault()
        const dollars = data[dollarsFieldName]
        dispatch(createBalance({ homeId, loanId, value: dollars }))
      }}
    >
      <Panel.Heading>
        <FormattedMessage
          id='Mortgages.editBalance.heading'
          defaultMessage='Update your loan balance'
        />
      </Panel.Heading>

      <Text align='center' size='l' variant='neutralCool' variantCount='700'>
        <FormattedMessage
          id='Mortgages.editBalance.valueHeading'
          defaultMessage="We've estimated your balance is {balance}"
          values={{
            balance: <Format.Currency value={estimatedValue} format='0,0' />,
          }}
        />
      </Text>

      <Text variant='neutralCool' variantCount='700' size='s' align='center'>
        <FormattedMessage
          id='Mortgages.editBalance.subheading'
          defaultMessage='We calculate all of your numbers based on loan details, today’s balance, and extra monthly principal payments.'
        />
      </Text>

      <FormField.Dollars
        className={styles.input}
        required
        conditions={dollarConditions}
        defaultValue={Math.round(estimatedValue)}
        captionMessage={
          <FormattedMessage
            id='Mortgages.editBalance.assumption'
            defaultMessage="Assuming you've paid this month's bill"
          />
        }
        data-qa='EditBalanceFormField'
      >
        <FormattedMessage
          id='Mortgages.editBalance.todayBalance'
          defaultMessage="Today's balance"
        />
      </FormField.Dollars>

      <Button.Group align='center' className={styles.buttonGroup}>
        <Button
          primary
          fullWidth
          disabled={saving}
          loading={saving}
          type='submit'
          data-qa='EditBalanceSaveButton'
        >
          <FormattedMessage
            id='Mortgages.editBalance.saveButton'
            defaultMessage='Save changes'
          />
        </Button>
        <Button
          minimal
          fullWidth
          disabled={saving}
          onClick={() => dispatch(cancelEditBalance())}
          data-qa='EditBalanceCancelButton'
        >
          <FormattedMessage
            id='Mortgages.editBalance.cancelButton'
            defaultMessage='Cancel'
          />
        </Button>
      </Button.Group>
    </Form>
  )
}

export default EditBalanceForm
